/* eslint-disable no-undef */
//import Slick from 'vue-slick';
const EventBus = window.EventBus;
import axios from 'axios';

export const VdpGallery = {
  //components: { Slick },
  props: ['images', 'vehicle', 'defaultPicture', 'cname','picture360','media', 'comingsoon', 'incoming'],
  data() {
    return {
      index: null,
      mainPicSrc: undefined,
      mainPicSrcWebp: this.images[0],
      themeDirectory: window.theme_directory,
      componentName: this.cname,
      isPano360: this.picture360,
      isMp4: this.media,
      thumbs: this.images
    }
  },
  created: function(){
    if(this.images[0])
      this.mainPicSrc = this.images[0].replace("http:", "https:");
    
    if(this.mainPicSrc == undefined) {
      if(this.comingsoon == true && this.incoming == true) {
        this.mainPicSrc = this.defaultPicture.split('-photo').join('-photo-incoming');
        return;
      }
      else {
        this.mainPicSrc = this.defaultPicture;
        return;
      }
    }else if (EventBus.checkValidCDN(this.mainPicSrc)) {
      this.checkUrlExists(this.mainPicSrc).then((status) => {
        if (status) {
          if (this.mainPicSrc.includes("-XXL"))
            this.mainPicSrc = this.mainPicSrc.replace(/-XXL/g, "-gallery.jpg").replace(/\?ts=.*/, '').replace('http:', 'https:');
          else if (this.mainPicSrc.includes(".png") || this.mainPicSrc.includes('invassets'))
            this.mainPicSrc = this.mainPicSrc.replace('http:', 'https:');
          else if (this.cname == 7 && this.mainPicSrc.includes('better-photo'))
            this.mainPicSrc = this.mainPicSrc;
          else if(this.mainPicSrc.includes('forddirect/cache/')){
            this.mainPicSrc = this.mainPicSrc.replace("http:", "https:").replace('-XXL','');
          }else
            this.mainPicSrc = this.mainPicSrc.replace('http:', 'https:') + "-gallery.jpg";
        } else {
          console.warn('** --> URL not found: ', this.mainPicSrc);
          this.mainPicSrc = this.mainPicSrc.split('-XXL').join('').replace('http:', 'https:');
        }
      });
    }

    this.images = [];
    if(this.thumbs.length > 0){
      this.thumbs.forEach((value, index) => {
        this.thumbs[index] = value.replace("http:", "https:");
        if (EventBus.checkValidCDN(value)) {
          this.checkUrlExists(value).then((status) => {
            if (status) {
              if (value.includes("-XXL")) {
                this.thumbs[index] = value.replace(/-XXL/g, "-gallery.jpg").replace(/\?ts=.*/, '').replace('http:', 'https:');
              }else if(value.includes('forddirect/cache/')){
                this.thumbs[index] = value.replace("http:", "https:").replace('-XXL','');
              }else
                this.thumbs[index] = value.replace('http:', 'https:') + "-gallery.jpg";
            } else {
              console.warn('** --> URL not found: ', value);
              this.thumbs[index] = value.replace('-XXL', '').replace('http:', 'https:');
            }
          });
        } else {
          this.thumbs[index] = value.replace('http:', 'https:');
        }
      });

      setTimeout(() => {
        this.images = this.thumbs;
      }, 200);
    }

    if(this.picture360){
      this.images.unshift(this.picture360);
    }
    if(this.media){
      this.images.unshift(this.media);
    }
  },
  methods: {
    checkUrlExists(url) {
      url = url.replace("http:", "https:");
      return axios.head(url)
        .then(response => true) // URL válida
        .catch(error => {
          if (error.response && error.response.status === 404) {
            return false; // URL no válida
          }
          return false; // Otro error
        });
    },
    validateMainUrl(){
      if(this.mainPicSrc == undefined) {
        if(this.comingsoon == true && this.incoming == true) {
          this.mainPicSrc = this.defaultPicture.split('-photo').join('-photo-incoming');
          return;
        }
        else {
          this.mainPicSrc = this.defaultPicture;
          return;
        }
      }            
    },
    sendGAEvent() {
      var payload = {
      'event_category': 'LBX-Veh-Gallery-'+ this.componentName, 
      'event_action': 'LBX-Click',
      'event_label': 'LBX-' + this.vehicle, 
      'event_photoid': 'LBX-Main', 
      'event_component_name': 'LBX-Vdp-Gallery-'+ this.componentName
      };

      window.sendGAEvent('LBX-Picture-View' , payload);
    },
    changeImg(id) {
      var payload = {
        'event_category': 'LBX-Veh-Gallery-'+ this.componentName,
       'event_action': 'LBX-Click',
       'event_label': 'LBX-' + this.vehicle,
       'event_photoid': 'LBX-'+id,
       'event_component_name': 'LBX-Vdp-Gallery-'+ this.componentName
     } 
     window.sendGAEvent('LBX-Picture-View' , payload);
    },
    imgLoadMainOnError() {
    if(this.comingsoon == true && this.incoming == true) {
      this.mainPicSrc = this.defaultPicture.split('-photo').join('-photo-incoming');
    }
    else 
      this.mainPicSrc = this.defaultPicture;
    },
    thumbnailImgLoadOnError(index, prefixLabel) {
      let prefix = (prefixLabel) ? prefixLabel : "img_";

      this.$refs[prefix + index][0].src = this.defaultPicture;
        if(this.$refs[prefix + index] && this.$refs[prefix + index][0] && this.$refs[prefix + index][0].parentNode && this.$refs[prefix + index][0].parentNode.children){
          for (let i = 0; i < this.$refs[prefix + index][0].parentNode.children.length; i++) {
            this.$refs[prefix + index][0].parentNode.children[i].srcset = this.defaultPicture;
            
            if(this.$refs[prefix + index][0].parentNode.children[i].src){
              this.$refs[prefix + index][0].parentNode.children[i].src = this.defaultPicture;
            }
            if(this.$refs[prefix + index][0].parentNode.children[i].getAttribute('data-src')){
              this.$refs[prefix + index][0].parentNode.children[i].setAttribute("data-src", this.defaultPicture);
            }
          }
        }

    },
    thumbnailImgMobileLoadOnError(index) {
      let prefix = 'img_mobile_';
      this.$refs['img_mobile_' + index][0].src = this.defaultPicture;
      
      if(this.$refs[prefix + index] && this.$refs[prefix + index][0] && this.$refs[prefix + index][0].parentNode && this.$refs[prefix + index][0].parentNode.children){
        for (let i = 0; i < this.$refs[prefix + index][0].parentNode.children.length; i++) {
          this.$refs[prefix + index][0].parentNode.children[i].srcset = this.defaultPicture;
          
          if(this.$refs[prefix + index][0].parentNode.children[i].src){
            this.$refs[prefix + index][0].parentNode.children[i].src = this.defaultPicture;
          }
          if(this.$refs[prefix + index][0].parentNode.children[i].getAttribute('data-src')){
            this.$refs[prefix + index][0].parentNode.children[i].setAttribute("data-src", this.defaultPicture);
          }
        }
      }
    },
    thumbnailImgExpandLoadOnError(index) {
      let prefix = 'img_expand_';
      this.$refs['img_expand_' + index][0].src = this.defaultPicture;

      if(this.$refs[prefix + index] && this.$refs[prefix + index][0] && this.$refs[prefix + index][0].parentNode && this.$refs[prefix + index][0].parentNode.children){
        for (let i = 0; i < this.$refs[prefix + index][0].parentNode.children.length; i++) {
          this.$refs[prefix + index][0].parentNode.children[i].srcset = this.defaultPicture;
          
          if(this.$refs[prefix + index][0].parentNode.children[i].src){
            this.$refs[prefix + index][0].parentNode.children[i].src = this.defaultPicture;
          }
          if(this.$refs[prefix + index][0].parentNode.children[i].getAttribute('data-src')){
            this.$refs[prefix + index][0].parentNode.children[i].setAttribute("data-src", this.defaultPicture);
          }
        }
      }

    },
    thumbnailImgExpandMobileLoadOnError(index) {
      let prefix = 'img_expand_mobile_';
      this.$refs['img_expand_mobile_' + index][0].src = this.defaultPicture;

      if(this.$refs[prefix + index] && this.$refs[prefix + index][0] && this.$refs[prefix + index][0].parentNode && this.$refs[prefix + index][0].parentNode.children){
        for (let i = 0; i < this.$refs[prefix + index][0].parentNode.children.length; i++) {
          this.$refs[prefix + index][0].parentNode.children[i].srcset = this.defaultPicture;
          
          if(this.$refs[prefix + index][0].parentNode.children[i].src){
            this.$refs[prefix + index][0].parentNode.children[i].src = this.defaultPicture;
          }
          if(this.$refs[prefix + index][0].parentNode.children[i].getAttribute('data-src')){
            this.$refs[prefix + index][0].parentNode.children[i].setAttribute("data-src", this.defaultPicture);
          }
        }
      }

    },
    goToCompare(id) {
      var compare = {};
      if (!localStorage.compare) {
        var Obj = {
          ids: [id],
        }
        localStorage.setItem('compare', JSON.stringify(Obj));
      }
      else {
        compare = JSON.parse(localStorage.compare);

        if (compare.ids.indexOf(id) == -1)
          compare.ids.push(id);

        if (compare.ids.length > 4) {
          compare.ids.splice(0, 1);
        }
        localStorage.compare = JSON.stringify(compare)
      }

      compare = JSON.parse(localStorage.compare);

      var urlIds = [];
      var j = 0;
      for (var i = compare.ids.length - 1; i >= 0; i--) {
        if (j >= 4)
          break;

        urlIds.push(compare.ids[i]);
        j++;
      }

      window.location.href = '/compare/?vehicles=' + urlIds.join('|');
    }
  }
}
